import terminologyService from '../services/terminology'
import { createResourceReducer } from './resourceReducer'
import { setSuccessNotification, setErrorNotification } from './notificationReducer'
import { parseErrorMessage } from '../services/utils.js/errorParser'

const TERMINOLOGY_PERMISSION_DENIED = 'Permission Denied: You must be a staff member or terminology admin to perform this action'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'terminology',
    label: 'Glossary',
    labelPlural: 'Glossary entries',
    service: terminologyService,
    permissionDeniedMessage: TERMINOLOGY_PERMISSION_DENIED,
})

export const { appendResource: appendTerminology, destroyResource: destroyTerminology, changeResource: changeTerminology } = actions
export const { initializeResources: initializeTerminology, deleteResource: deleteTerminology, searchResources: searchTerminology, refreshResource: refreshTerminology } = thunks

export const createTerminology = (data, admin) => {
    return async dispatch => {
        try {
            const terminology = await terminologyService.create(data)
            if (admin) {
                dispatch(appendTerminology(terminology))
                dispatch(setSuccessNotification('Glossary entry created successfully'))
            } else {
                dispatch(setSuccessNotification('Your request has been submitted'))
            }
            return true
        } catch (error) {
            const errorMessage = parseErrorMessage(error, 'Error submitting request, please try again later')
            if (admin) {
                dispatch(setErrorNotification(`Error creating glossary entry: ${errorMessage}`))
            } else {
                dispatch(setErrorNotification(`Error submitting request: ${errorMessage}`))
            }
            return false
        }
    }
}

export const updateTerminology = (id, data, admin) => {
    return async dispatch => {
        if (!admin) {
            dispatch(setErrorNotification(TERMINOLOGY_PERMISSION_DENIED))
            return false
        }
        try {
            const terminology = await terminologyService.update(id, data)
            dispatch(changeTerminology(terminology))
            dispatch(setSuccessNotification('Glossary entry updated successfully'))
            return true
        } catch (error) {
            const errorMessage = parseErrorMessage(error, 'Update of glossary entry failed')
            dispatch(setErrorNotification(`Update failed: ${errorMessage}`))
            return false
        }
    }
}

export default reducer
